

















import { Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import RecommendationCard from '@/componentsV2/molecules/RecommendationCard/RecommendationCard.vue';
import { IBusinessType } from '@/models/business';
import BillingModel from '@/views/Models/BillingModel.vue';
import { StartGuideTask } from '@/models/start-guide';
import { widgetIsActive } from '@/router/validators/utils';
import { getBillingIsHidden, getBillingIsPending } from '@/utils/billing';

@Component({
  components: {
    Typography,
    RecommendationCard
  }
})
export default class HomeRecomendations extends BillingModel {
  @Prop() overviewData?: any;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get billingStatus() {
    return this.businessInfo.subscriptionStatus;
  }

  get tasks() {
    return (
      (this.$store.getters['startGuide/getTasks'] as StartGuideTask[]) || []
    );
  }

  get businessRegistration() {
    return this.$store.getters['registration/getBusinessRegistration'] || [];
  }

  get activeOnlineProvider() {
    return widgetIsActive();
  }

  get cards() {
    const registrationWidget = this.businessRegistration.filter(
      (item: any) => item.slug === 'widget-setup'
    )[0];
    return [
      {
        feature: 'branded-coin',
        text: 'Create your own <br/>customized <b>digital <br/>currency</b>',
        buttonText: 'Customize coin',
        buttonTextColor: '#CC1964',
        backgroundColor: '#CC1964',
        textColor: '#FFF',
        show:
          this.getTaskFilter('customize-coin') &&
          !this.getTaskFilter('customize-coin').completed,
        onClick: () => {
          this.$router.push('/coin/image');
        }
      },
      {
        feature: 'offer',
        text: 'Attract new <br/>members and <b>grow <br/>your business.</b>',
        buttonText: 'Create new offer',
        buttonTextColor: '#3E24D6',
        backgroundColor: '#3E24D6',
        textColor: '#FFF',
        show:
          this.businessInfo.type !== IBusinessType.ONLINE &&
          this.getTaskFilter('special-coins') &&
          !this.getTaskFilter('special-coins').completed,
        onClick: () => {
          this.$router.push('/special-coins-offers');
        }
      },
      {
        feature: 'coin-network',
        text: 'Connect with <br/><b>members</b> Like Never <br/>Before!',
        buttonText: 'Join Coin Network',
        buttonTextColor: '#D66B00',
        backgroundColor: '#D66B00',
        textColor: '#FFF',
        // The only card here not gated by `inactiveBilling`, so hiding billing
        // does not reach it: a business still PENDING when the flag flips would
        // keep seeing "Join Coin Network" over a button that now returns without
        // opening anything (TWISM-19007).
        show: !getBillingIsHidden() && getBillingIsPending(),
        onClick: () => {
          this.onClickUpgrade({
            props: {
              welcomeCtaText: 'Explore Dashboard',
              origin: 'Home Banner'
            }
          });
        }
      },
      {
        feature: 'loyalty-program',
        text: 'Create <b>loyal customers</b> <br/>through rewards!',
        buttonText: 'Launch Loyalty Program',
        buttonTextColor: '#10222D',
        backgroundColor: '#FDCB1C',
        textColor: '#10222D',
        show:
          this.getTaskFilter('reward-coins') &&
          !this.getTaskFilter('reward-coins').completed,
        onClick: () => {
          this.$router.push('/program-status');
        }
      },

      {
        feature: 'sell-coins',
        text: 'Increase revenue <br/>with <b>digital Gift Cards.</b>',
        buttonText: 'Create new campaign',
        buttonTextColor: '#278F3E',
        backgroundColor: '#278F3E',
        textColor: '#FFF',
        show:
          this.getTaskFilter('sell-coins') &&
          !this.getTaskFilter('sell-coins').completed,
        onClick: () => {
          this.$router.push('/sell-coins');
        }
      },
      {
        feature: 'widget',
        text:
          'Customize as you <br/>like, your widget is <b><br/>your brand!</b>',
        buttonText: 'Custom your widget',
        buttonTextColor: '#10222D',
        backgroundColor: '#AEE85D',
        textColor: '#10222D',
        show:
          this.businessInfo.type === IBusinessType.BOTH &&
          !this.businessInfo.onlineMerchantSignup &&
          registrationWidget &&
          registrationWidget.businessSignupSteps[0].status !== 'seen',
        onClick: () => {
          this.$router.push('/loyalty-widget');
        }
      },
      {
        feature: 'referral',
        text:
          'Referral Program: <br/>reward your members <br/>and <b>get new ones!</b>',
        buttonText: 'Create campaign',
        buttonTextColor: '#640EBE',
        backgroundColor: '#640EBE',
        textColor: '#FFF',
        show:
          this.businessInfo.type !== IBusinessType.INSTORE &&
          !this.overviewData.hasActiveReferralProgram &&
          this.activeOnlineProvider,
        onClick: () => {
          this.$router.push('/referral-program');
        },
        onlineOrder: 2
      },
      {
        feature: 'invite-customer',
        text:
          '<b>Bring existing <br/>customers</b> into your <br/>Loyalty Program!',
        buttonText: 'Invite your customers',
        buttonTextColor: '#FFF',
        buttonBackgroundColor: '#10222D',
        backgroundColor: '#FF92EE',
        textColor: '#10222D',
        show:
          this.businessInfo.type !== IBusinessType.INSTORE &&
          this.getTaskFilter('invite-customers') &&
          !this.getTaskFilter('invite-customers').completed &&
          this.activeOnlineProvider,
        onlineOrder: 1,
        onClick: () => {
          this.$router.push('/customer-import');
        }
      },
      {
        feature: 'social-rewards',
        text:
          'More followers and <br/>shares by <b>rewarding <br/>with Coins.</b>',
        buttonText: 'Create new campaign',
        buttonTextColor: '#312470',
        backgroundColor: '#312470',
        textColor: '#FFF',
        show:
          this.businessInfo.type !== IBusinessType.INSTORE &&
          !this.overviewData.hasActiveSocialRewards,
        onlineOrder: 5,
        onClick: () => {
          this.$router.push('/social-rewards');
        }
      },
      {
        feature: 'welcome-coins',
        text:
          'Welcome Coins are a <br/>great way to <b>get new <br/>customers.</b>',
        buttonText: 'Create new campaign',
        buttonTextColor: '#10222D',
        backgroundColor: '#1D4040',
        textColor: '#FFF',
        show:
          this.getTaskFilter('welcome-coins') &&
          !this.getTaskFilter('welcome-coins').completed,
        onlineOrder: 3,
        onClick: () => {
          this.$router.push('/marketing-center/offer-free-coins');
        }
      },

      {
        feature: 'email-automation',
        text:
          'We just made it easier <br/>to <b>get in touch</b> with <br/>members',
        buttonText: 'Explore Email Automation',
        buttonTextColor: '#10222D',
        backgroundColor: '#10222D',
        textColor: '#FFF',
        show:
          this.businessInfo.type !== IBusinessType.INSTORE &&
          !this.overviewData.hasActiveCustomerAcquisition,
        onlineOrder: 4,
        onClick: () => {
          this.$router.push('/activation-emails');
        }
      },
      {
        feature: 'metrics',
        text: '<b>Track the success</b> <br/>of your campaigns.',
        buttonText: 'Business Metrics',
        buttonTextColor: '#FFF',
        buttonBackgroundColor: '#10222D',
        backgroundColor: '#EFDBB2',
        textColor: '#10222D',
        show: true,
        onClick: () => {
          this.$router.push('/performance/overview');
        }
      },
      {
        feature: 'help-center',
        text: "<b>Need help?</b> We've <br/>got answers!",
        buttonText: 'Help Center',
        buttonTextColor: '#10222D',
        buttonBackgroundColor: '#FFFFFF',
        backgroundColor: '#77C8B8',
        textColor: '#10222D',
        show: true,
        onClick: () => {
          window.open('https://support.twism.com/hc/en-us', '_blank');
        }
      }
    ]
      .map(item => ({
        ...item,
        src: require(`@/assets/img/home-cards${
          this.$mobileCheck() ? '/mobile' : ''
        }/${item.feature}.png`)
      }))
      .filter((item: any) => !!item.show)
      .sort((a, b) => {
        if (!a.onlineOrder || this.businessInfo.type !== IBusinessType.ONLINE)
          return 0;
        if (a.onlineOrder < (b.onlineOrder || 0)) {
          return -1;
        }
        if (a.onlineOrder > (b.onlineOrder || 0)) {
          return 1;
        }
        return 0;
      })
      .slice(0, 2);
  }

  getTaskFilter(name: string) {
    return this.tasks.filter(item => item.slug === name)[0];
  }
}
